import React from 'react';
import { PlusIcon } from '@components/icons';
import { LanguageSelector } from '@components/organisms/language-selector';
import { ConcordiumLogo } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/docs-verification-steps/start-custom-partner/logo/concordium';
import type { HeaderProps } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/header/types';
import Box from '@mui/material/Box';
import { useAppSelector } from '@store';
import { useAppTheme } from '@theme';

export const Header = ({ logo }: HeaderProps) => {
    const theme = useAppTheme();
    const domain = useAppSelector((state) => state.domain);
    const {
        settings: { logo_settings },
    } = domain;
    const logoLongSrc = logo ?? logo_settings.logo_wide_url;
    const isCustomPartner = useAppSelector(
        (state) => state.docsVerification.sdkOptions?.customPartner?.concordium,
    );

    return (
        <Box
            sx={{
                display: 'flex',
                gap: 1,
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
            }}
            style={theme.components?.docVerWidget?.header?.style}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 0.5,
                    color: 'primaryA1',
                }}
            >
                <Box
                    component={logoLongSrc ? 'img' : 'div'}
                    src={logoLongSrc}
                    sx={{ width: '80px' }}
                    alt='logo'
                    style={theme.components?.docVerWidget?.startStep?.logo?.style}
                />
                {isCustomPartner && (
                    <React.Fragment>
                        <PlusIcon />
                        <ConcordiumLogo />
                    </React.Fragment>
                )}
            </Box>
            <LanguageSelector sx={{ ml: 'auto', maxWidth: '200px' }} />
        </Box>
    );
};
